import styled from 'styled-components';
import { slideIn } from 'Styles/effects';

export const Wrapper = styled.div`
  background: ${({ theme }) => theme.backgrounds.modal};
  display: flex;
  flex-direction: column;
  position: relative;
  box-shadow: ${({ theme }) => theme.boxShadow.modal};
  border-top: 10px solid #53a9ff;
  border-radius: 8px 8px 2px 2px;
  padding: 36px 35px 36px 40px;
  overflow: hidden !important;
  max-height: 85%;
  width: 610px;
  ${slideIn}
`;
Wrapper.displayName = 'Wrapper';

export const Content = styled.div`
  height: calc(100% - 134px);
  overflow-y: auto;
  padding-right: 5px;
`;
Content.displayName = 'Content';
